<script>
  import {
    getBoolean,
    i18n,
    imageResolver,
    localizeUri,
  } from '@/commons/utils';
  import { levelSliding } from './nav-utils.js';
  import Header from './Header.svelte';
  import SvgIcon from './SvgIcon.svelte';
  import HighlightedSports from './HighlightedSports.svelte';
  import { createEventDispatcher } from 'svelte';

  export let category = {};
  export let depthLevel;
  export let ariaLabelName;
  export let defaultSport;
  export let displayedSubLevel = null;
  export let showListingLink =
    cube && cube.config
      ? getBoolean(cube.config.feature_menu_showListingLink)
      : false;

  const dispatch = createEventDispatcher();

  const closeSubMenu = () => {
    displayedSubLevel = null;
    defaultSport = null;
  };
</script>

<style type="less">/*     Links     */
/*     Main colors     */
/*     Forms     */
/* tiny font sizes (mobile first) */
/* font-weights */
/* font-weights china limits */
/* Path */
/* Font families */
/* Default font stacks */
/* Chinese font stacks */
/* Breakpoints */
/* === ============= === */
/* VARS */
/*== Colors
//
//## Gray and brand colors for use across Bootstrap. */
/*== Scaffolding
//
//## Settings for some of the most global styles. */
/* Background color for `<body>`. */
/* Global text color on `<body>`. */
/* Global textual link color. */
/* Link hover color set via `darken()` function. */
/* Link hover decoration.alert */
/*== Typography
//
//## Font, line-height, and color for body text, headings, and more. */
/* Default monospace fonts for `<code>`, `<kbd>`, and `<pre>`. */
/* Unit-less `line-height` for use in components like buttons. */
/* Computed "line-height" (`font-size` * `line-height`) for use with `margin`, `padding`, etc. */
/* By default, this inherits from the `<body>`. */
/*== Iconography
//
//## Specify custom location and filename of the included Glyphicons icon font. Useful for those including Bootstrap via Bower. */
/* Load fonts from this directory. */
/* File name for all font files. */
/* Element ID within SVG icon file. */
/*== Components
//
//## Define common padding and border radius sizes and more. Values based on 14px text and 1.428 line-height (~20px to start). */
/* Global color for active items (e.g., navs or dropdowns). */
/* Global background color for active items (e.g., navs or dropdowns). */
/* Width of the `border` for generating carets that indicator dropdowns. */
/* Carets increase slightly in size for larger components. */
/*== Tables
//
//## Customizes the `.table` component with basic values, each used across all table variations. */
/* Padding for `<th>`s and `<td>`s. */
/* Padding for cells in `.table-condensed`. */
/* Default background color used for all tables. */
/* Background color used for `.table-striped`. */
/* Background color used for `.table-hover`. */
/* Border color for table and cell borders. */
/*== Buttons
//
//## For each of Bootstrap's buttons, define text, background and border color. */
/* Allows for customizing button radius independently from global border radius */
/*== Forms
//
//## */
/* `<input>` background color */
/* `<input disabled>` background color */
/* Text color for `<input>`s */
/* `<input>` border color */
/* TODO: Rename `@input-border-radius` to `@input-border-radius-base` in v4 */
/* Default `.form-control` border radius */
/* This has no effect on `<select>`s in some browsers, due to the limited stylability of `<select>`s in CSS. */
/* Large `.form-control` border radius */
/* Small `.form-control` border radius */
/* Border color for inputs on focus */
/* Placeholder text color */
/* Default `.form-control` height */
/* Large `.form-control` height */
/* Small `.form-control` height */
/* `.form-group` margin */
/* Background color for textual input addons */
/* Border color for textual input addons */
/* Disabled cursor for form controls and buttons. */
/*== Dropdowns
//
//## Dropdown menu container and contents. */
/* Background for the dropdown menu. */
/* Dropdown menu `border-color`. */
/* Dropdown menu `border-color` **for IE8**. */
/* Divider color for between dropdown items. */
/* Dropdown link text color. */
/* Hover color for dropdown links. */
/* Hover background for dropdown links. */
/* Active dropdown menu item text color. */
/* Active dropdown menu item background color. */
/* Disabled dropdown menu item background color. */
/* Text color for headers within dropdown menus. */
/* Deprecated `@dropdown-caret-color` as of v3.1.0 */
/*-- Z-index master list
//
// Warning: Avoid customizing these values. They're used for a bird's eye view
// of components dependent on the z-axis and are designed to all work together.
//
// Note: These variables are not generated into the Customizer. */
/*== Media queries breakpoints
//
//## Define the breakpoints at which your layout will change, adapting to different screen sizes. */
/* Extra small screen / phone */
/* Deprecated `@screen-xs` as of v3.0.1 */
/* Deprecated `@screen-xs-min` as of v3.2.0 */
/* Deprecated `@screen-phone` as of v3.0.1 */
/* Deprecated `@screen-sm` as of v3.0.1 */
/* Deprecated `@screen-tablet` as of v3.0.1 */
/* Deprecated `@screen-md` as of v3.0.1 */
/* Deprecated `@screen-desktop` as of v3.0.1 */
/* Deprecated `@screen-lg` as of v3.0.1 */
/* Deprecated `@screen-lg-desktop` as of v3.0.1 */
/*== Grid system
//
//## Define your custom responsive grid. */
/* Number of columns in the grid. */
/* Padding between columns. Gets divided in half for the left and right. */
/* Point at which the navbar becomes uncollapsed. */
/* Point at which the navbar begins collapsing. */
/*== Container sizes
//
//## Define the maximum width of `.container` for different screen sizes. */
/* Small screen / tablet */
/* For `@screen-sm-min` and up. */
/* Medium screen / desktop */
/* For `@screen-md-min` and up. */
/* Large screen / wide desktop */
/* For `@screen-lg-min` and up. */
/*== Navbar
//
//## */
/* Basics of a navbar */
/*== Inverted navbar */
/*== Navs
//
//## */
/*== Shared nav styles */
/*== Tabs */
/*== Pills */
/*== Pagination
//
//## */
/*== Pager
//
//## */
/*== Jumbotron
//
//## */
/*== Form states and alerts
//
//## Define colors for form feedback states and, by default, alerts. */
/*== Tooltips
//
//## */
/* Tooltip max width */
/* Tooltip text color */
/* Tooltip background color */
/* Tooltip arrow width */
/* Tooltip arrow color */
/*== Popovers
//
//## */
/* Popover body background color */
/* Popover maximum width */
/* Popover border color */
/* Popover fallback border color */
/* Popover title background color */
/* Popover arrow width */
/* Popover arrow color */
/* Popover outer arrow width */
/* Popover outer arrow color */
/* Popover outer arrow fallback color */
/*== Labels
//
//## */
/* Default label background color */
/* Primary label background color */
/* Success label background color */
/* Info label background color */
/* Warning label background color */
/* Danger label background color */
/* Default label text color */
/* Default text color of a linked label */
/*== Modals
//
//## */
/* Padding applied to the modal body */
/* Padding applied to the modal title */
/* Modal title line-height */
/* Background color of modal content area */
/* Modal content border color */
/* Modal content border color **for IE8** */
/* Modal backdrop background color */
/* Modal backdrop opacity */
/* Modal header border color */
/* Modal footer border color */
/*== Alerts
//
//## Define alert colors, border radius, and padding. */
/*== Progress bars
//
//## */
/* Background color of the whole progress component */
/* Progress bar text color */
/* Variable for setting rounded corners on progress bar. */
/* Default progress bar color */
/* Success progress bar color */
/* Warning progress bar color */
/* Danger progress bar color */
/* Info progress bar color */
/*== List group
//
//## */
/* Background color on `.list-group-item` */
/* `.list-group-item` border color */
/* List group border radius */
/* Background color of single list items on hover */
/* Text color of active list items */
/* Background color of active list items */
/* Border color of active list elements */
/* Text color for content within active list items */
/* Text color of disabled list items */
/* Background color of disabled list items */
/* Text color for content within disabled list items */
/*== Panels
//
//## */
/* Border color for elements within panels */
/*== Thumbnails
//
//## */
/* Padding around the thumbnail image */
/* Thumbnail background color */
/* Thumbnail border color */
/* Thumbnail border radius */
/* Custom text color for thumbnail captions */
/* Padding around the thumbnail caption */
/*== Wells
//
//## */
/*== Badges
//
//## */
/* Linked badge text color on hover */
/* Badge text color in active nav link */
/* Badge background color in active nav link */
/*== Breadcrumbs
//
//##

@breadcrumb-padding-vertical:   8px;
@breadcrumb-padding-horizontal: 15px;
/* Breadcrumb background color */
/* Breadcrumb text color */
/* Text color of current page in the breadcrumb */
/* Textual separator for between breadcrumb elements */
/*== Carousel
//
//## */
/*== Close
//
//## */
/*== Code
//
//## */
/*== Type
//
//## */
/* Horizontal offset for forms and lists. */
/* Text muted color */
/* Abbreviations and acronyms border color */
/* Headings small color */
/* Blockquote small color */
/* Blockquote font size */
/* Blockquote border color */
/* Page header border color */
/* Width of horizontal description list titles */
/* Point at which .dl-horizontal becomes horizontal */
/* Horizontal line color. */
/* Tools */
/*    Main mixins    */
/* ICON FONT - DecathlonCube and iconfont*/
/* LOADING GIF */
/* Rate element
usage
  .star-rate(@width);
*/
/* Hide content visually, but keep them availbale for seo and screen reader */
/* FONT */
/* font-[stretch value]-[weight keyword]-[style value] */
/* LEGACY */
/**
 * ##Buttons
 * File : path/button.less TODO
 */
/**
 * ### Generic button
 * `.cta`
 *
 *     @example
 *     a.cta(href="#")|My button
 *
 */
/**
 * ### Colors
 * Color class available : `.grey` `.yellow`
 *
 *     @example
 *     a.cta(href="#")|My button
 *     a.cta.yellow(href="#")|My button
 *     a.cta.grey(href="#")|My button
 *
 */
/**
 * ### With icon
 * [See icons available](http://iconslink.com).
 *
 *     @example
 *     a.cta.cta-icon.left(href="#")|My button
 *       span.icon.icon-search
 *
 */
/**
 * ### Small size
 * Size class available : `.small`
 *
 *     @example
 *     a.cta.small(href="#")|My button
 *     a.cta.yellow.small(href="#")|My button
 *     a.cta.grey.small(href="#")|My button
 *
 */
/**
 * ### Arrow
 * Arrow class available : `.left` `.right`
 *
 *     @example
 *     a.cta.left(href="#")|My button
 *     a.cta.yellow.right(href="#")|My button
 *     a.cta.grey.right(href="#")|My button
 *
 */
/**
 * ### Others display
 * Class available : `.disabled`
 *
 *     @example
 *     a.cta.disabled(href="#")|My button
 *
 */
/*
 * I converted the SCSS mixin to LESS for the awesome coders like myself in response to a blog post on 37Signals - http://37signals.com/svn/posts/3271-easy-retina-ready-images-using-scss
 *
 * Update: 2014-08-04 - Updated a long-standing bug where retina images were shown no matter what in the first background-image property.
 *                    - Updated retina media query to be more reliable ()
 * Update: 2013-11-13 - Picked up another technique thanks to reading this post from Tyler Tate, auto-fill in the second filename for the retina image, http://tylertate.com/blog/2013/06/11/retina-images-using-media-queries-and-LESS-CSS.html
 * Update: 2013-04-16 - Have recently found a few use cases when using a retina pattern from Subtle Patterns on the <body>, this has come in handy
 * Update: 2013-04-05 - Some research in the Wordpress Core(http://core.trac.wordpress.org/ticket/22238#comment:5) was pointed out that some tests may be redundant (Thanks @kbav) so I've cleaned these up
 * Update: 2012-12-29 - Updated AGAIN to add MS IE10 declaration and fix wonky 'min--moz-' declaration which Mozilla engineers are aware of
 * Update: 2012-11-21 - Updated again based on information from an article I found, added dppx and changed opera ratio to target more devices (http://www.uifuel.com/hd-retina-display-media-queries/)
 * Update: 2012-11-17 - Updated based on Wordpress Core to target even more devices! Thanks @Wordpress <3 (http://core.trac.wordpress.org/changeset/22629)
 */
/**
 * ##Titles
 * File : path/texts.less
 */
/**
 * ### Title header
 * `.title-header`
 *
 *     @example
 *     h1.title-header|My title
 *
 */
/**
 * ### Title header variant
 * `.title-header-variant`
 *
 *     @example
 *     h1.title-header-variant|My title variant
 *
 */
/**
 * ### Title product
 * `.title-product`
 *
 *     @example
 *     h1.title-product|My title product
 *
 */
/**
 * ### Subtitle
 * `.title-subtitle`
 *
 *     @example
 *     h1.title-subtitle|My subtitle
 *
 */
/**
 * ### Mixin titlePage
 * `.titlePage(@size, @color, @spanColor)`
 *
 *     @example
 *     a.cta-link.upper(href="#")|My link
 *
 * Example :
 * `.titlePage(1em, @white, @black)`
 *
 */
@-webkit-keyframes zoomicon {
  from {
    opacity: 0;
    -webkit-transform: scale(0.1, 0.1);
    -moz-transform: scale(0.1, 0.1);
    -ms-transform: scale(0.1, 0.1);
    transform: scale(0.1, 0.1);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}
@keyframes zoomicon {
  from {
    opacity: 0;
    -webkit-transform: scale(0.1, 0.1);
    -moz-transform: scale(0.1, 0.1);
    -ms-transform: scale(0.1, 0.1);
    transform: scale(0.1, 0.1);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}
@-webkit-keyframes vibe {
  from {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  to {
    opacity: 0;
    -webkit-transform: scale(1.3, 1.3);
    -moz-transform: scale(1.3, 1.3);
    -ms-transform: scale(1.3, 1.3);
    transform: scale(1.3, 1.3);
  }
}
@keyframes vibe {
  from {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  to {
    opacity: 0;
    -webkit-transform: scale(1.3, 1.3);
    -moz-transform: scale(1.3, 1.3);
    -ms-transform: scale(1.3, 1.3);
    transform: scale(1.3, 1.3);
  }
}
.item {
  display: flex;
  align-items: center;
  width: calc(100% + 0.2rem);
  color: inherit;
  min-height: 5rem;
  margin-top: -0.1rem;
  margin-right: -0.1rem;
  margin-left: -0.1rem;
  padding: 1.5rem;
  border: 0.1rem solid #edeff1;
}
.item:not(.see-all):not(.listing-link) {
  font-weight: 700;
}
.item:not(.alt-item):hover,
.item:not(.alt-item):focus {
  color: #fff;
  background-color: #0082c3;
}
.item:focus {
  outline: 0.1rem dotted rgba(255, 255, 255, 0.8);
  outline-offset: -0.3rem;
}
.sublevel--first > .item:not(.alt-item) {
  background-color: #edeff1;
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.5), #fff 60%);
  transition: background-color 0.25s ease;
}
.sublevel--first > .item:not(.alt-item) span {
  color: #0082c3;
}
.sublevel--first > .item:not(.alt-item):hover,
.sublevel--first > .item:not(.alt-item):focus {
  color: #0082c3;
  background-color: #fff;
}
.alt-item {
  background-color: #edeff1;
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), #fff);
  transition: background-color 0.25s ease;
}
.alt-item:hover,
.alt-item:focus {
  background-color: #fff;
}
.alt-item:focus {
  outline-color: rgba(175, 177, 179, 0.7);
}
button {
  text-align: left;
  text-transform: inherit;
  background-color: transparent;
}
.img-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 7rem;
  width: 7rem;
  margin: -1rem 1rem -1rem -1rem;
  text-align: center;
  overflow: hidden;
}
img {
  height: auto;
  width: auto;
  max-width: 100%;
}
em {
  display: block;
  color: #0082c3;
  font-weight: bold;
  font-style: inherit;
}
span:not(.nav-icon) {
  flex-grow: 1;
}
.nav-icon {
  height: 2.5rem;
  width: 2.5rem;
  min-width: 2.5rem;
  margin-left: 1rem;
}
.sublevel {
  overflow-y: auto;
  overflow-x: hidden;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  max-width: calc(100vw - 6.6rem);
  padding-top: 6.6rem;
  padding-bottom: 2rem;
  padding-left: 0;
  color: #575859;
  background-color: #fff;
  z-index: 2;
}
@supports (position: sticky) {
  .sublevel {
    padding-top: 0;
  }
}
.parent {
  overflow: hidden;
}
@media (min-width: 801px) {
  a,
  button {
    padding-right: 3rem;
    padding-left: 3rem;
  }
  .img-holder {
    width: 8rem;
    min-height: 8rem;
  }
  .sublevel {
    max-width: 40rem;
  }
}
</style>

<div
  class="sublevel"
  class:sublevel--first={depthLevel === 1}
  class:parent={displayedSubLevel}
  role="menu"
  aria-labelledby={ariaLabelName}
  transition:levelSliding
  data-tnr-opened-panels>
  <Header on:closeSubMenu {depthLevel} title={category.displayName || ''} />

  {#if depthLevel > 1 && category.categoryLinks && category.categoryLinks.overriddenUrl && category.displayName}
    <a
      class="item alt-item see-all"
      href={localizeUri(category.categoryLinks.overriddenUrl)}
      role="menuitem"
      on:focus={closeSubMenu}
      data-tnr-menu-panel-subcategories
      data-type="all-about">
      {#if category.imageUrlMap && category.imageUrlMap.menuThumbnail}
        <div class="img-holder">
          <img
            src={imageResolver(category.imageUrlMap.menuThumbnail, {
              size: '120x120',
              extension: 'png',
            })}
            alt=""
            role="presentation" />
        </div>
      {/if}
      <span>
        {i18n('navigation.allAbout')}
        <em>{category.displayName}</em>
      </span>
      <span class="nav-icon" role="presentation">
        <SvgIcon icon="arrow" />
      </span>
    </a>
  {/if}

  {#each category.childCategories as childCategory, index}
    {#if childCategory.childCategories && childCategory.childCategories.length && childCategory.displayName}
      <button
        id="cat-{depthLevel}{index}"
        class="item"
        class:alt-item={childCategory.imageUrlMap && childCategory.imageUrlMap.menuThumbnail}
        role="menuitem"
        aria-expanded={displayedSubLevel === childCategory.repositoryId}
        data-type={depthLevel <= 1 ? 'main-category' : 'sub-category'}
        on:focus={closeSubMenu}
        on:click={e => {
          displayedSubLevel = childCategory.repositoryId;
        }}>
        {#if childCategory.imageUrlMap && childCategory.imageUrlMap.menuThumbnail}
          <div class="img-holder">
            <img
              src={imageResolver(childCategory.imageUrlMap.menuThumbnail, {
                size: '120x120',
                extension: 'png',
              })}
              alt=""
              role="presentation" />
          </div>
        {/if}
        <span>{childCategory.displayName}</span>

        <span class="nav-icon" role="presentation">
          <SvgIcon icon="arrow" />
        </span>
      </button>
    {:else if childCategory.categoryLinks && childCategory.categoryLinks.overriddenUrl && childCategory.displayName}
      <a
        href={localizeUri(childCategory.categoryLinks.overriddenUrl)}
        class="item"
        class:alt-item={childCategory.imageUrlMap && childCategory.imageUrlMap.menuThumbnail}
        role="menuitem"
        on:focus={closeSubMenu}
        data-tnr-menu-panel-categories
        data-type="sub-category">
        {#if childCategory.imageUrlMap && childCategory.imageUrlMap.menuThumbnail}
          <div class="img-holder">
            <img
              src={imageResolver(childCategory.imageUrlMap.menuThumbnail, {
                size: '120x120',
                extension: 'png',
              })}
              alt=""
              role="presentation" />
          </div>
        {/if}
        <span>{childCategory.displayName}</span>
        <span class="nav-icon" role="presentation">
          <SvgIcon icon="arrow" />
        </span>

      </a>
    {/if}

    {#if childCategory.childCategories.length && displayedSubLevel == childCategory.repositoryId}
      <svelte:self
        category={childCategory}
        ariaLabelName="cat-{depthLevel}{index}"
        on:closeSubMenu={closeSubMenu}
        bind:defaultSport
        depthLevel={depthLevel + 1} />
    {/if}
  {/each}

  {#if showListingLink && category.categoryLinks && category.categoryLinks.listing}
    <a
      href={localizeUri(category.categoryLinks.listing)}
      class="item listing-link"
      role="menuitem"
      on:focus={closeSubMenu}>
      <span>{i18n('navigation.link.listing')}</span>
      <span class="nav-icon" role="presentation">
        <SvgIcon icon="arrow" />
      </span>
    </a>
  {/if}

  {#if category.associatedSportCategories && category.associatedSportCategories.length}
    <HighlightedSports
      on:closeSubMenu={closeSubMenu}
      title={i18n('navigation.associatedSports')}
      sports={category.associatedSportCategories}
      {depthLevel}
      tnrString="data-tnr-menu-associated-sports" />
  {/if}

</div>



// WEBPACK FOOTER //
// ./src/commons/navigation/SubLevel.svelte